<template>
  <div>
    <el-dropdown split-button type="info" size="mini" style="width: 96px;">
      蚂蚁链
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <!-- <el-button @click="withHold('sign')" type="warning" size="mini">签署合同</el-button> -->
          <el-button @click="createOrderchain()" type="warning" size="mini"
            >签署合同</el-button
          >
        </el-dropdown-item>
        <el-dropdown-item>
          <!-- <el-button @click="withHold('create')" type="primary" size="mini">代扣签约</el-button> -->
          <el-button @click="cancelOrderchain()" type="primary" size="mini"
            >代扣解约</el-button
          >
        </el-dropdown-item>
        <el-dropdown-item>
          <!-- <el-button @click="withHold('cancel')" type="primary" size="mini">取消代扣</el-button> -->
          <el-button @click="showCancelOrderMYLDia()" type="primary" size="mini"
            >取消代扣</el-button
          >
        </el-dropdown-item>
        <el-dropdown-item>
          <!-- <el-button @click="withHold('close')" type="danger" size="mini">关闭订单</el-button> -->
          <el-button @click="showCloseOrderMYLDia()" type="danger" size="mini"
            >关闭订单</el-button
          >
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 蚂蚁链代扣解约确认 -->
    <el-dialog
      title="蚂蚁链代扣解约确认"
      :visible.sync="showCancelChainDia"
      width="50%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="chainForm" label-width="100px">
        <el-form-item label="操作动作">
          <el-radio v-model="chainForm.operate" label="AGREE">同意</el-radio>
          <el-radio v-model="chainForm.operate" label="REFUSE">拒绝</el-radio>
        </el-form-item>
        <!-- 选择失败 -->
        <el-form-item label="拒绝原因" v-if="chainForm.operate == 'REFUSE'">
          <el-select
            v-model="chainForm.refuse_reason_code"
            placeholder="请选择拒绝原因"
          >
            <el-option
              v-for="item in refuseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户欠款金额" v-if="chainForm.operate == 'REFUSE'">
          <el-input v-model="chainForm.user_owe_money"></el-input>
        </el-form-item>
        <el-form-item
          label="用户进行中的服务"
          v-if="chainForm.operate == 'REFUSE'"
        >
          <el-input v-model="chainForm.user_in_service"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCancelChainDia = false">取 消</el-button>
        <el-button type="primary" @click="submitCancelChain">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="取消订单"
      :visible.sync="cancelMYLdia"
      width="30%"
      :before-close="handleClose1"
    >
      <!-- 选择成功 -->
      <el-select v-model="cancel_reason" placeholder="请选择取消原因">
        <el-option
          v-for="item in cancelOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelMYLdia = false">取 消</el-button>
        <el-button type="primary" @click="cancelOrderMYL">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="订单关闭"
      :visible.sync="closeMYLdia"
      width="30%"
      :before-close="handleClose2"
    >
      <el-input v-model="closeReason" placeholder="请填写关闭原因"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeMYLdia = false">取 消</el-button>
        <el-button type="primary" @click="closeOrderMYL">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.el-dropdown-menu__item + .el-dropdown-menu__item {
  margin-top: 5px;
}
</style>

<script>
// import useApi from "@/api/useApi";
import OrderApi from "@/api/order.js";

import CloseInput from "./CloseInput.vue";

// const types = {
//   sign: '签署蚂蚁链合同',
//   create: '生成代扣签约链接',
//   cancel: '取消蚂蚁链代扣',
//   close: '关闭订单'
// }

// const apiMap = {
//   sign: 'createContract',
//   create: 'createHoldSign',
//   cancel: 'cancelWithholdPlan',
//   close: 'closeOrder'
// }

export default {
  name: "AntWidthHold",
  components: { CloseInput },
  props: {
    item: Object
  },
  data() {
    return {
      closeReason: "",
      // 控制展示蚂蚁链解约弹窗
      showCancelChainDia: false,
      // 蚂蚁链代扣取消申请的拒绝的参数
      chainForm: {
        order_id: "",
        operate: "",
        refuse_reason_code: "",
        user_owe_money: "",
        user_in_service: ""
      },
      // 蚂蚁链代扣取消前的取消订单参数
      cancel_reason: "",
      cancelOptions: [
        {
          value: "RENTING_OUT",
          label: "退租"
        },
        {
          value: "RENTING_AND_RESALE",
          label: "租转售"
        }
      ],
      cancelMYLdia: false,
      closeMYLdia: false,
      order_id: ""
    };
  },
  methods: {
    // 蚂蚁链生成合同
    createOrderchain() {
      if (this.item.signNo !== "") {
        this.$message({
          type: "error",
          message: "合同已生成，请勿重复点击！"
        });
        return;
      }
      let data = {
        order_id: this.item.order_id
      };
      OrderApi.createOrderchain(data, true)
        .then(res => {
          this.$message({
            type: "success",
            message: "生成成功"
          });
        })
        .catch(err => {
          this.$message({
            type: "success",
            message: "生成失败"
          });
        });
    },
    // 蚂蚁链解约
    cancelOrderchain() {
      let self = this;
      self.order_id = this.item.order_no;
      console.log(this.item);
      if (this.item.sign_str_status == "APPLY_TERMINATE") {
        self.showCancelChainDia = true;
        self.chainForm = {};
      } else {
        this.$message({
          type: "success",
          message: "未申请解约"
        });
      }
    },
    // 确定解约蚂蚁链代扣
    submitCancelChain() {
      let self = this;
      self.chainForm.order_id = self.order_id;
      // 同意解约  AGREE
      if (self.chainForm.operate == "AGREE") {
        self.chainForm.refuse_reason_code = "";
        self.chainForm.user_owe_money = "";
        self.chainForm.user_in_service = "";
      }
      // 取消解约
      OrderApi.cancelChain(self.chainForm, true).then(res => {
        self.showCancelChainDia = false;
      });
    },
    /*关闭确认*/
    handleClose() {
      this.dialogVisible = false;
    },
    handleClose1() {
      this.cancelMYLdia = false;
    },
    handleClose2() {
      this.closeMYLdia = false;
    },
    // 取消代扣
    showCancelOrderMYLDia() {
      this.order_id = this.item.order_no;
      this.cancelMYLdia = true;
    },
    // 蚂蚁链-未到期代扣批量取消   确定解约蚂蚁链的前提先取消订单
    cancelOrderMYL() {
      let self = this;
      let Params = {};
      Params.order_id = self.order_id;
      Params.cancel_reason = self.cancel_reason;
      // 批量取消
      OrderApi.antchainAtoWithholdPlanCancel(Params, true).then(res => {
        this.$message({
          type: "success",
          message: "取消订单成功"
        });
        this.cancelMYLdia = false;
      });
    },
    showCloseOrderMYLDia() {
      this.order_id = this.item.order_no;
      this.closeMYLdia = true;
    },
    // 蚂蚁链-订单关闭
    closeOrderMYL() {
      let self = this;
      let Params1 = {};
      Params1.order_id = self.order_id;
      Params1.closeReason = self.closeReason;
      // 订单关闭
      OrderApi.closeOrder(Params1, true).then(res => {
        this.$message({
          type: "success",
          message: "订单关闭成功"
        });
        this.closeMYLdia = false;
      });
    }
    // async withHold(val) {
    //   console.log(val)
    //   let vNode = "请确认是否<span class=\"red\">" + types[val] + "</span>?";

    //   if (val === 'close') {
    //     console.log('close')
    //     vNode = this.$createElement('CloseInput', {
    //       on: {
    //         change: (val) => {
    //           this.closeReason = val;
    //         }
    //       }
    //     });
    //   }
    //   console.log(vNode)
    //   await this.$confirm(vNode, "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     dangerouslyUseHTMLString: true
    //   });
    //   const params = { order_id: this.item.order_id };

    //   if (val === 'close') {
    //     params.close_reason = this.closeReason;
    //   }

    //   await useApi()[apiMap[val]](params);
    //   if (val == 'sign') {
    //     this.$message({
    //       message: "签约成功",
    //       type: "success",
    //     });
    //   }
    // }
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/views/order/order/dialog/AntWithHold/AntWithHold.vue